import React from 'react';
import CustomSelect from "../../../components/common/select/Select";
import trashBtn from "../../../assets/images/trashBtn.svg";
import addBtn from "../../../assets/images/addBtn.svg";
import "../style/promotion.scss";


export default function SBB({item,switched,checked,budgetRestrictionChange,
    buyUomSelectChange,
otherDetailsChange,
handleSlabFromChange,
handleSlabToChange,
handleSlabNormChange,
handleSlabContChange,
changeSlabType,
handleRemoveSlabs,
handleAddSlabs,
index,
enumData,
selectedBuyUom,
slabFrom,
isExtended
}) {

    if(!item.Slabs){
      return 'gheljasjdkasd'
    }
  return (
     <>
                                <div className="control_panel_upper">
                                  <div className="panel_first">
                                    <label>Project Code </label>
                                    <label> {item.ProjectCode} </label>

                                    <div className="cp_inner_second">
                                      <label> Budget Restriction</label>
                                      <label className="long_input">
                                        {" "}
                                        <input
                                          type="number"
                                          value={item.BudgetRestriction}
                                          name="budgetRestriction"
                                          onChange={(e) =>
                                            {isExtended===true? void 0 : budgetRestrictionChange(e, index)}
                                          }
                                        disabled={isExtended===true?true:false}
                                        style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8,height: '2vw'}
                                        :{height: '2vw'}}
                                        />{" "}
                                      </label>
                                    </div>
                                  </div>
                                  <div className="panel_first">
                                    <label>Detail of Offer </label>
                                    <label> {!item.DetailOfOffer ? "-" : item.DetailOfOffer} </label>

                                    <label style={{ paddingBottom: "6px", paddingTop: '1px' }}>
                                      {" "}
                                  Buy UOM{" "}
                                      <span className="mandatory_fields">
                                        {item.SlabType !==
                                          "795f46df-01a3-48f9-9143-06ea6c2cf658" ? "*" : ""}
                                      </span>
                                    </label>
                                    <label >
                                      <CustomSelect.MySelect
                                        isDisabled={isExtended ===true ? true : item.SlabType ===
                                          "795f46df-01a3-48f9-9143-06ea6c2cf658" ? true : false}
                                        placeholder={item.SlabType ===
                                          "795f46df-01a3-48f9-9143-06ea6c2cf658" ? "" : "Buy Uom"}
                                        options={

                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return (
                                                  filter_item.Type === "BUY_UOM" && filter_item.guid !== "c5ddb6ef-847e-44fc-9950-debe5a1d3793" && filter_item.guid !== "e907be85-2af9-4ca6-9c94-79dcde6507a1"
                                                );
                                              })
                                              .map((map_item) => {
                                                // map_item.Label !== 'RS-PKR' ?
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                }
                                              })
                                            : []
                                        }
                                        value={
                                          enumData
                                            ? enumData
                                              .filter((filter_item) => {
                                                return selectedBuyUom === ""
                                                  ? filter_item.guid ===
                                                  item.BuyUom
                                                  : filter_item.guid ===
                                                  selectedBuyUom;
                                              })
                                              .map((map_item) => {
                                                return {
                                                  value: map_item.guid,
                                                  label: map_item.Label,
                                                };
                                              })
                                            : void 0
                                        }
                                        // value={detailData!==undefined?  detailData.selectedPromotionType : selectedPromotionType }
                                        onChange={(val) =>
                                          buyUomSelectChange(val.value, index)
                                        }
                                      />
                                    </label>

                                    {/* <div className="cp_inner_second">
                                    <label>ROI%</label>
                                    <label style={{ paddingTop: "1vh" }}>
                                      {item.Roi}
                                    </label>
                                  </div> */}
                                  </div>
                                  <div className="panel_first">
                                    <label>Other Details </label>
                                    <label>
                                      {" "}
                                      <input
                                        type="text"
                                        className="other_detail_input"
                                        onChange={(e) => {isExtended===true? void 0 : otherDetailsChange(e.target.value, index)}}
                                        name="otherDetails"
                                        value={item.OtherDetails}
                                        disabled={isExtended===true?true:false}
                                        style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8, paddingLeft: '1vw' }
                                        :
                                        { paddingLeft: '1vw' }
                                        }
                                      />{" "}
                                    </label>
                                    <label style={{ paddingTop: "0.7vh" }}>ROI%</label>
                                    <label >
                                      {item.Roi}
                                    </label>
                                  </div>
                                </div>

                                <div style={{ marginTop: "30px" }}>
                                  <label style={{ marginBottom: "20px", }}>
                                    Slabs Type
                                </label>
                                  <div className="date_toggle_main" style={{ marginTop: "15px" }}>
                                    <div>
                                      <p style={{ marginTop: "20px" }}>Amount</p>
                                    </div>
                                    <div>
                                      <label className="__switched">
                                        {
                                          checked === false &&
                                            switched === false ? (
                                              <input
                                                type="checkbox"
                                                // checked
                                                value={switched}
                                                onClick={() => {isExtended===true? void 0 : changeSlabType(index)}}
                                                disabled={isExtended===true?true:false}
                                                style={isExtended===true?{cursor:'not-allowed'}
                                                :
                                                void 0
                                                }
                                              />
                                            ) : (
                                              <input
                                                type="checkbox"
                                                checked
                                                value={switched}
                                                onClick={() => {isExtended===true? void 0 : changeSlabType(index)}}
                                                disabled={isExtended===true?true:false}
                                                style={isExtended===true?{cursor:'not-allowed'}
                                                :
                                                void 0
                                                }
                                              />
                                            )}
                                        <span className="__slider __round"></span>
                                      </label>
                                    </div>
                                    <div>
                                      <p style={{ marginTop: "20px" }}>Quantity</p>
                                    </div>
                                  </div>

                                  {item.Slabs.map((elm, childIndex) => (
                                    <div className="slab-list-container">
                                      <div className="slab-label-input">
                                        <label>Slab From</label>
                                        <label className="long_input">
                                          {" "}
                                          <input
                                            type="number"
                                            name="slabFrom"
                                            value={
                                              slabFrom !== "isEmpty"
                                                ? slabFrom
                                                : elm.SlabFrom
                                            }
                                            onChange={(e) =>
                                              {
                                                isExtended ===true ? void 0 :
                                                handleSlabFromChange(
                                                e,
                                                childIndex,
                                                index
                                              )
                                              }
                                            }
                                            disabled={isExtended===true?true:false}
                                            style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}
                                            :
                                            void 0
                                            }
                                          />{" "}
                                        </label>
                                      </div>
                                      <div className="slab-label-input">
                                        <label>Slab To</label>
                                        <label className="long_input">
                                          {" "}
                                          <input
                                            type="number"
                                            name="slabTo"
                                            value={elm.SlabTo}
                                            onChange={(e) =>
                                              {
                                                isExtended ===true ? void 0 :
                                                handleSlabToChange(
                                                e,
                                                childIndex,
                                                index
                                              )}
                                            }
                                            disabled={isExtended===true?true:false}
                                            style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}
                                            :
                                            void 0
                                            }
                                          />{" "}
                                        </label>
                                      </div>
                                      <div className="slab-label-input">
                                        <label>Norm(%)</label>
                                        <label className="long_input">
                                          {" "}
                                          <input
                                            type="number"
                                            name="slabNorm"
                                            value={elm.Norm}
                                            onChange={(e) =>
                                              {
                                                isExtended ===true ? void 0 :
                                                handleSlabNormChange(
                                                e,
                                                childIndex,
                                                index
                                              )}
                                            }
                                            disabled={isExtended===true?true:false}
                                            style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}
                                            :
                                            void 0
                                            }
                                          />{" "}
                                        </label>
                                      </div>
                                      <div className="slab-label-input">
                                        <label>Contribution(%)</label>
                                        <label className="long_input">
                                          {" "}
                                          <input
                                            type="number"
                                            name="slabNorm"
                                            value={!elm.Contribution ? 0 : elm.Contribution}
                                            onChange={(e) =>
                                              {
                                                isExtended ===true ? void 0 :
                                                handleSlabContChange(
                                                e,
                                                childIndex,
                                                index
                                              )}
                                            }
                                            disabled={isExtended===true?true:false}
                                            style={isExtended===true?{cursor:'not-allowed',backgroundColor:'hsl(0,0%,95%)',opacity:0.8}
                                            :
                                            void 0
                                            }
                                          />{" "}
                                        </label>
                                      </div>

                                      {item.Slabs.length === 1 ? null : (
                                        <div
                                          className="slab-remove"
                                          onClick={() =>
                                            {
                                              isExtended ===true ? void 0 :
                                              handleRemoveSlabs(
                                              childIndex,
                                              index
                                            )}
                                          }
                                          style={isExtended===true?{cursor:'not-allowed'}:void 0}
                                        >
                                          <img src={trashBtn} alt='' />
                                          <span>
                                            <u style={isExtended===true?{color:'lightgrey',opacity:0.8}
                                            :
                                            void 0
                                            }>Remove</u>
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  ))}

                                  {item.Slabs.length === 5 ? (
                                    <div className="slab-add">
                                      {/* <img src={addBtn}/> */}
                                      <span style={{ color: "lightgrey" }}>
                                        <u>Add More Slabs</u>
                                      </span>
                                    </div>
                                  ) : (
                                      <div
                                        className="slab-add"
                                        onClick={() =>
                                          {
                                            isExtended ===true ? void 0 :
                                            handleAddSlabs(
                                            index,
                                            item.Slabs[0].Norm
                                          )}
                                        }
                                          style={isExtended===true?{cursor:'not-allowed'}:void 0}
                                      >
                                        <img src={addBtn} alt='' />
                                        <span>
                                          <u style={isExtended===true?{color:'lightgrey',opacity:0.8}
                                            :
                                            void 0
                                            }>Add More Slabs</u>
                                        </span>
                                      </div>
                                    )}
                                </div>
                              </>
                            
  );
}
